/* eslint-disable */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-delete-button',
  templateUrl: './delete-button.component.html',
  styleUrls: ['./delete-button.component.scss'],
})

export class DeleteButtonComponent implements OnInit {

  @Output() click: EventEmitter<any> = new EventEmitter();
  @Input() title: string = '';
  @Input() disabledClass: string = 'pointer';
  @Input() additionalClass = ''

  ngOnInit(): void {}

  public clickEmitter() {
  }
}
